import React from 'react';
import { useSelector } from 'react-redux';


import { COMPONENTTYPE } from '../components/common/constant/componentType';
import Header from '../components/common/header/Header';

export const hasAccess = (
  user,
  permissions = [],
  roles = [],
) => {
  const { role, permissions: userPermissions = [] } = user;
  const userRoles = role ? [role] : [];
  const hasRoleAccess = roles.length === 0 || roles.some(r => userRoles.includes(r));
  const hasPermissionAccess = permissions.length === 0 || permissions.some(p => userPermissions.includes(p));
  return hasRoleAccess && hasPermissionAccess;
};

const UnauthorizedMessage = () => (
  <div className="w-full h-40 flex justify-center items-center mt-4 p-4">
    <span className="text-[20px]">You are not authorized to view this content</span>
  </div>
);

const stopEvent = (e) => {
  e.preventDefault();
  e.stopPropagation();
};

const makeReadOnly = (element) => {
  if (!React.isValidElement(element)) return element;

  const props = {};

  // Block interactive events
  const blockEvents = [
    "onClick", "onDoubleClick", "onMouseDown", "onMouseUp",
    "onKeyDown", "onKeyUp", "onFocus", "onBlur", "onContextMenu",
    "onChange", "onInput", "onSubmit"
  ];

  blockEvents.forEach(evt => {
    props[evt] = stopEvent;
  });

  // Disable form inputs
  if (element.type === "input" || element.type === "textarea" || element.type === "select" || element.props?.role === 'button') {
    props.disabled = true;
    props.readOnly = true;
    props.tabIndex = -1;
  }

  // Recursively process children
  const children = React.Children.map(element.props.children, child => makeReadOnly(child));

  return React.cloneElement(element, props, children);
};

const ReadOnlyWrapper = ({ children }) =>
  React.Children.map(children, child => makeReadOnly(child));

const AllowedAccess = ({
  applyOnCondtion = true,
  permissions = [],
  roles = [],
  type = COMPONENTTYPE.ELEMENT,
  isAuthMsg = false,
  optionalComponent = null,
  mode = "hide",
  children,
}) => {
  const { role, permissions: userPermissions = [] } = useSelector((state) => state.user);
  const userRoles = role ? [role] : [];

  if(!applyOnCondtion){
    return <>{children}</>;
  }

  const hasRoleAccess = roles.length === 0 || roles.some(r => userRoles.includes(r));
  const hasPermissionAccess = permissions.length === 0 || permissions.some(p => userPermissions.includes(p));
  
  if (hasRoleAccess && hasPermissionAccess) {
    return <>{children}</>;
  }

   if (mode === "readonly") {
    return <ReadOnlyWrapper>{children}</ReadOnlyWrapper>;
  }

  const shouldShowMessage = type === COMPONENTTYPE.PAGE || isAuthMsg;

  if (optionalComponent) {
    return optionalComponent; // Render the passed-in component
  }

  if (type === COMPONENTTYPE.PAGE) {
    return <><Header headertitle="Access Denied" /><UnauthorizedMessage /></>
  }

  return shouldShowMessage ? <UnauthorizedMessage /> : null;
};

export default AllowedAccess;
